module.exports = __webpack_public_path__ + "img/list-left.aae39c5a.svg";